module.exports = __webpack_public_path__ + "img/download-gb.e9dc4602.webp";